import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Select from "react-select";
import {
  Box,
  Container,
  Stack,
  Typography,
  Button,
  TextField,
  Grid,
} from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import ReactSelect from 'react-select';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import SweetAlert from 'sweetalert2';

const validationSchema = Yup.object().shape({
    code: Yup.string().required('code name is required'),
 

});

const ProcedureRegistration = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const ProcedureId = location.state?.ProcedureId || 0; // Retrieve insuranceId from location.state

  const token = localStorage.getItem('Thyra_Token');

   const [practiceId, setCurrentPracticeId] = useState(() => {
      const practiceId = localStorage.getItem("default_practice");
      return practiceId ? parseInt(practiceId, 10) : 0;
    });
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const fields = [
    'id',
    'code',
    'description',
    'charges',
    'units',
    'modifier1',
    'modifier2',
    'modifier3',
    'modifier4',
    
  ];

  const defaultValues = {
    id: 0,
    code: '',
    description: '',
    charges: '',
    units: '',
    modifier1: '',
    modifier2: '',
    modifier3: '',
    modifier4:'',
  };

  const {
    register,
    control,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    resolver: yupResolver(validationSchema),
    defaultValues,
  });

  const [submitting, setSubmitting] = useState(false);
  const [isDialogOpenResp, setDialogOpenResp] = useState(false);

  console.log('uzair ahmed insuranceId:', ProcedureId); // Debugging

  useEffect(() => {
    if (ProcedureId > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Procedures/getProceduresById?id=${ProcedureId}`,
          { headers }
        )
        .then((response) => {
          const data = response; // Adjust based on your API response structure
          const fieldMapping = {
            id: data.id,
            // practice_id: data.practice_id,
            code: data.code,
            description: data.description || '',
            charges: data.charges || '',
            phoneNo: data.phoneNo,
            units: data.units || '',
            modifier1: data.modifier1,
            modifier2: data.modifier2 || '',
            modifier3: data.modifier3 || '',
            modifier4: data.modifier4 || '',
          };

          Object.entries(fieldMapping).forEach(([field, value]) => {
            setValue(field, value);
          });
        })
        .catch((error) => {
          console.error('Error fetching insurance data:', error);
        });
    }
  }, [ProcedureId, setValue]);

  const onSubmit = (data) => {
    if (submitting) return;
    setSubmitting(true);

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Procedures/AddEditProcedures`,
        data,
        { headers }
      )
      .then((response) => {
        if (response.id) {
          setDialogOpenResp(true);
          setTimeout(() => {
            navigate('/Procedure');
            setDialogOpenResp(false);
          }, 1000);
        }
        setSubmitting(false);
      })
      .catch((error) => {
        console.error('Submission error:', error.response || error);
        SweetAlert.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.message || 'Failed to submit insurance data!',
        });
        setSubmitting(false);
      });
  };

  const handleCancel = () => {
    navigate('/Procedure');
  };
  const labelStyles = {
    fontSize: "14px",
    fontWeight: "500",
    color: "#000",
    marginBottom: "8px",
    display: "block",
  };

  // Consistent TextField styling
  const textFieldStyles = {
    "& .MuiInputBase-root": {
      height: "40px",
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#d1d1d1",
      },
      "&:hover fieldset": {
        borderColor: "#2B7B7E",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#2B7B7E",
      },
    },
  };

  return (
    <Container sx={{ pt: 10, pb: 4, maxWidth: 'lg' }}>
        <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ fontWeight: "bold", color: "#2B7B7E" }}>
                Procedure Registration
                </Typography>
              </Box>
      <Dialog
        open={isDialogOpenResp}
        onClose={() => setDialogOpenResp(false)}
        PaperProps={{
          style: {
            marginRight: '5px',
            float: 'right',
            marginTop: '5px',
            color: 'red',
            cursor: 'pointer',
          },
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '8px',
            width: '500px',
          }}
        >
          <CheckCircleIcon style={{ fontSize: '100px', color: 'green' }} />
          <h5
            style={{
              textAlign: 'center',
              fontSize: '16px',
              fontWeight: 'normal',
              color: '#444444',
            }}
          >
            Procedure {ProcedureId > 0 ? 'updated' : 'added'} successfully
          </h5>
          <DialogContent />
        </div>
      </Dialog>
    <Box
        sx={{
          bgcolor: "#FFFFFF",
          borderRadius: "12px",
          boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
          p: 4,
        }}
      >
           
        <Grid container spacing={2}>
          {/* Full Name */}
          <Grid item xs={12} md={6}>
            <Typography sx={labelStyles}>CPT Code</Typography>
            <TextField
              {...register("code", {
                required: "Please enter Code",
              })}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Code"
              error={!!errors.code}
              helperText={errors.code?.message}
              sx={textFieldStyles}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
              }}
            />
          </Grid>

          {/* Shirtname */}
          <Grid item xs={6} md={6}>
            <Typography sx={labelStyles}>Description</Typography>
            <TextField
              {...register("description")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Description"
              sx={textFieldStyles}
            />
          </Grid>
          {/* type */}
          <Grid item xs={6} md={6}>
            <Typography sx={labelStyles}>Charges</Typography>
            <TextField
              {...register("charges")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Charges"
              sx={textFieldStyles}
            />
          </Grid>
            {/* Email Address */}
            <Grid item xs={6} md={6}>
            <Typography sx={labelStyles}>Units</Typography>
            <TextField
              {...register("units")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your units"
              sx={textFieldStyles}
            />
          </Grid>
          {/* Phone No */}
          <Grid item xs={6} md={6}>
            <Typography sx={labelStyles}>Modifier1</Typography>
            <TextField
              {...register("modifier1")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Modifier1"
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
              }}
              sx={textFieldStyles}
            />
          </Grid>

          {/* Fax */}
          <Grid item xs={6} md={6}>
            <Typography sx={labelStyles}>Modifier2</Typography>
            <TextField
              {...register("modifier2")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Modifier2"
              sx={textFieldStyles}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
              }}
            />
          </Grid>

          {/* Address */}
          <Grid item xs={6} md={6}>
            <Typography sx={labelStyles}>Modifier3</Typography>
            <TextField
              {...register("modifier3")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Modifier3"
              sx={textFieldStyles}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
              }}
            />
          </Grid>

          {/* City */}
          <Grid item xs={6} md={6}>
            <Typography sx={labelStyles}>Modifier4</Typography>
            <TextField
              {...register("modifier4")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Modifier4"
              sx={textFieldStyles}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
              }}
            />
          </Grid>
        </Grid>

        {/* Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            mt: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleCancel}
            sx={{
              width: "100px",
              height: "35px",
              backgroundColor: "#2B7B7E",
              color: "white",
              borderRadius: "80px",
              fontSize: "14px",
              "&:hover": { backgroundColor: "#1a1a1a" },
            }}
          >
            <CancelOutlinedIcon
              fontSize="medium"
              style={{ color: "red", paddingRight: "5px" }}
            />
            Cancel
          </Button>
          <Button
            onClick={handleSubmit(onSubmit)}
            disabled={submitting}
            sx={{
              width: "100px",
              height: "35px",
              backgroundColor: "#2B7B7E",
              color: "white",
              borderRadius: "80px",
              fontSize: "14px",
              "&:hover": { backgroundColor: "#1a1a1a" },
            }}
          >
            <SaveOutlinedIcon sx={{ color: "white", mr: 1 }} />
            Save
          </Button>
        </Box>
      </Box>

  
    </Container>
  );
};

export default ProcedureRegistration;